<template>
    <div v-if="!cookieAccepted" class="cookie-banner">
      <p>
        This site uses cookies to enhance your experience. By continuing, you agree to our 
        <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
      </p>
      <button @click="acceptCookies">Accept</button>
      <button @click="rejectCookies">Reject</button>
    </div>
  </template>
  
  <script>
  import VueCookies from "vue-cookies";
  
  export default {
    data() {
      return {
        cookieAccepted: VueCookies.isKey("user-consent"),
        // cookieAccepted: !!sessionStorage.getItem("user-consent") // Banner shows only if no value exists
      };
    },
    methods: {
      acceptCookies() {
        VueCookies.set("user-consent", "accepted", "30d"); // Expires in 30 days
        this.cookieAccepted = true;
      },
      rejectCookies() {
        VueCookies.set("user-consent", "rejected", "30d");
        this.cookieAccepted = true;
      },
//     acceptCookies() {
//     sessionStorage.setItem("user-consent", "accepted"); // Stores only for the current tab
//     this.cookieAccepted = true; 
//   },
//   rejectCookies() {
//     sessionStorage.setItem("user-consent", "rejected"); // Stores only for the current tab
//     this.cookieAccepted = true; 
//   }
    },
  };
  </script>
  
  <style scoped>
  .cookie-banner {
    position: fixed;
    bottom: 41px;
    left: 33px;
    width: 54%;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 10px;
    text-align: center;
  }
  


  button {
    margin: 0 5px;
    padding: 5px 10px;
    cursor: pointer;
    color: black;
    background-color: white;
  }
  </style>
  